<div 
    class="navbar-mobile"
>

    <ul class="navbar-mobile__list d-flex justify-content-evenly align-items-end">

        @for (item of navbarItems; track item.id) {
            <li 
                class="navbar-mobile__item d-flex flex-column align-items-center"
                [ngClass]="{
                    'navbar-mobile__item--is-activated': item.isActivated && !item.isNovaCotacao,
                    'navbar-mobile__item--is-nova-cotacao': item.isNovaCotacao
                }"
                (click)="handleClickItem(item, $event)"
            >
                <span>
                    <ng-icon [name]="item.icon"></ng-icon>
                </span>
                {{item.txt}}
            </li>
        }
            
    </ul>
    
    <!-- BOTTOM SHEET dos grupos de ramos quando o usuário clicar no botão de "Nova cotação" -->
    <app-bottom-sheet 
        sheetID="sheet-nova-cotacao"
        [title]="'Nova cotação' + (grupoRamoSelecionado ? ' - ' + grupoRamoSelecionado.txt : '')"
        [show]="showBottomSheetRamos"
        (showEmitter)="showBottomSheetRamos = $event"
    >

        <div class="bottom-sheet__list-container">
            <!-- ARRAY DE GRUPOS RAMOS -->
            <ul class="bottom-sheet__list bottom-sheet__list--grupos">
                @for (grupo of gruposRamos; track grupo.id) {
                    <li class="bottom-sheet__item" (click)="handleClickGrupoRamo(grupo, $event)">
                        <ng-icon class="bottom-sheet__ramo-icon" [name]="grupo.icon"></ng-icon>
                        {{grupo.txt}}
    
                        <ng-icon class="bottom-sheet__item-arrow" name="heroChevronRight"></ng-icon>
                    </li>
                }
            </ul>
            
            <!-- ARRAY DE RAMOS DO GRUPO SELECIONADO -->
            <div
                class="bottom-sheet__list bottom-sheet__list--ramos"
                [ngClass]="{'bottom-sheet__list--ramos-active': showRamosDoGrupoSelecionado}"
            >
                <ul>
                    @for (ramo of grupoRamoSelecionado?.subRamos; track ramo.id) {
                        <li class="bottom-sheet__item" (click)="handleClickRamo(ramo)">
                            <ng-icon class="bottom-sheet__ramo-icon" [name]="ramo.icon"></ng-icon>
                            {{ramo.txt}}
                        </li>
                    }
                </ul>
                
                <span class="bottom-sheet__voltar-categorias" (click)="handleVoltarGruposRamos($event)">
                    <ng-icon name="heroChevronLeft"></ng-icon>
                    Voltar para categorias
                </span>
            </div>
        </div>


    </app-bottom-sheet>
    
    <!-- <div id="bottom-sheet" class="bottom-sheet" [@bottomSheetAnimation]="showBottomSheetRamos ? 'open' : 'closed'">
        <span class="bottom-sheet__title d-flex justify-content-between">
            Nova cotação {{grupoRamoSelecionado ? '- ' + grupoRamoSelecionado.txt : ''}}
            <ng-icon name="close" (click)="showBottomSheetRamos = false"></ng-icon>
        </span>

        <div class="bottom-sheet__list-container"> -->


            

            
        <!-- </div> -->

    <!-- </div> -->

</div>